module.exports = __webpack_public_path__ + "cd455783/img/settings-icon.121d9519.svg";